var _defs, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicereminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Invoice_reminder",
    "data-name": "Invoice reminder",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.78,
    height: 114.78,
    viewBox: "0 0 114.78 114.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_484",
    x: 75.107,
    y: 23.689,
    width: 14.563,
    height: 13.882,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38828",
    "data-name": "Path 38828",
    d: "M57.39,0A57.39,57.39,0,1,1,0,57.39,57.388,57.388,0,0,1,57.39,0",
    fill: "#de6634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38829",
    "data-name": "Path 38829",
    d: "M16.432,75.821l8.162,7.761,8.4-7.99,8.548,8.128,8.349-7.935,8.316,7.907,8.864-8.432,7.44,7.469V6.561H7.988V83.353Z",
    transform: "translate(16.14 13.258)",
    fill: "#f5f6f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38830",
    "data-name": "Path 38830",
    d: "M46.88,13.73H12.041a2.415,2.415,0,1,1,0-4.83H46.88a2.415,2.415,0,0,1,0,4.83",
    transform: "translate(24.244 23.288)",
    fill: "#e0e1e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38831",
    "data-name": "Path 38831",
    d: "M36.459,17.919H12.041a2.415,2.415,0,1,1,0-4.83H36.459a2.415,2.415,0,0,1,0,4.83",
    transform: "translate(24.243 34.25)",
    fill: "#e0e1e3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40642",
    "data-name": "Path 40642",
    d: "M36.791,32.409c-1.342-1.321-1-4.656-1-7.6a6.236,6.236,0,0,0-4.735-5.961,2.369,2.369,0,0,0-4.679,0,6.236,6.236,0,0,0-4.734,5.961c0,2.947.345,6.283-1,7.6s-2.983,2.048-2.983,4.062h8.222A2.666,2.666,0,0,0,28.7,38.962a2.666,2.666,0,0,0,2.812-2.491h8.261C39.774,34.457,38.134,33.73,36.791,32.409Z",
    transform: "translate(47.156 9.063)",
    fill: "#3c3c3b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Ellipse_484)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_484-2",
    "data-name": "Ellipse 484",
    cx: 5.781,
    cy: 5.441,
    rx: 5.781,
    ry: 5.441,
    transform: "translate(76.61 24.19)",
    fill: "#56aa1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicereminder);
export default __webpack_public_path__ + "static/media/Invoice reminder.369ff385e8d3a45507cb746cd76732cf.svg";
export { ForwardRef as ReactComponent };